export default "__VITE_ASSET__BLRjbzLI__"